var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c("div", { staticClass: "search-box" }, [
        _c("div", { staticClass: "search-box-shadow-frame" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchString,
                expression: "searchString"
              }
            ],
            ref: "searchInput",
            staticClass: "search-input",
            attrs: {
              type: "search",
              placeholder: "Suchbegriff oder Artikelnummer..."
            },
            domProps: { value: _vm.searchString },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchString = $event.target.value
                },
                function($event) {
                  return _vm.onValueChanged($event.target.value)
                }
              ],
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.search()
              },
              focus: function($event) {
                _vm.isSearchFocused = true
              },
              blur: function($event) {
                return _vm.onBlurSearchField($event)
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "search-button" }, [
            _c(
              "button",
              {
                staticClass: "search-submit",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    return _vm.search()
                  }
                }
              },
              [_vm._v("Finden")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "no-focus": !_vm.isSearchFocused,
                "no-results": !_vm.hasAutocompleteResults
              }
            },
            [
              _vm._t("autocomplete-suggestions", [
                _c(
                  "div",
                  { staticClass: "autocomplete-suggestionsps shadow bg-white" },
                  [
                    _c(
                      "div",
                      { staticClass: "sgg" },
                      [
                        _c("p", { staticClass: "hl" }, [
                          _vm._v("Suchvorschläge")
                        ]),
                        _vm._v(" "),
                        _c("search-suggestion-item", {
                          attrs: {
                            "show-count": true,
                            "show-additional-information": true,
                            "suggestion-type": "suggestion"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "its" },
                      [
                        _c("p", { staticClass: "hl" }, [_vm._v("Artikel")]),
                        _vm._v(" "),
                        _c("search-suggestion-item", {
                          attrs: {
                            "show-images": true,
                            "show-additional-information": true,
                            "suggestion-type": "item"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cats" },
                      [
                        _c("p", { staticClass: "hl" }, [_vm._v("Kategorien")]),
                        _vm._v(" "),
                        _c("search-suggestion-item", {
                          attrs: {
                            "show-count": true,
                            "show-additional-information": true,
                            "suggestion-type": "category"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }